import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import LangContext from "modules/shared/context/langContext";
import {
  GeneralStyledContent,
  StyledSearchForm,
} from "../../../../styled/common-styled";
import {
  Row,
  Col,
  Form,
  Select,
  Divider,
  Input,
  Spin,
  Button,
  Radio,
  TimePicker,
  InputNumber,
  message,
  Switch,
  Icon,
  Tabs,
} from "antd";
import Breadcrumb from "../../../shared/components/Breadcrumb";
import FormDivider from "../../../shared/components/FormDivider";
import AudioPlayer from "./AudioPlayer";
import * as yup from "yup";
import {
  getAudioList,
  loadVehicleGroup,
  loadVehicle,
  loadVehicleByVehicleGroup,
  loadPlants,
  createAxios,
  getBroadcastToIcingById,
  loadLocationGroup,
  loadLocationByLocationGroup,
} from "../fetchAPI/apiClient";
import moment from "moment";
import TableTransfer from "../../../shared/components/TableTransfer";
const { Item } = Form;
const FormItem = Item;
const { TabPane } = Tabs;

const BroadcastForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [dataFromEdit, setDataFromEdit] = useState(null);
  const [vehicleGroup, setVehicleGroup] = useState([]);
  const [locationGroup, setLocationGroup] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [plant, setPlant] = useState([]);

  let setFieldValueFormikRef = useRef(null);

  useEffect(() => {
    createAxios(props.accessToken);

    if (props.type === "edit") {
      setLoading(true);
      getBroadcastToIcingById(props.id, (statusCode, response) => {
        setDataFromEdit(response.data.data);
        setLoading(false);
      });
    } else {
      loadData();
    }
  }, [props.type, props.companyId, props.vehicleVisibility, props.accessToken]);

  useEffect(() => {
    loadData();
  }, [dataFromEdit]);

  const loadData = () => {
    const setFieldValue = setFieldValueFormikRef.current;
    getAudioList(
      {
        company_id: props.companyId,
      },
      (status, response) => {
        if (response.status == 200) {
          // setAudioList(response.data);
          setFieldValue("audioList", response.data);
        }
        loadVehicleGroup(
          { company_id: props.companyId },
          (statusCode, response) => {
            setVehicleGroup(response.data.data);
            loadVehicle(
              {
                company_id: props.companyId,
                vehicle_visibility: props.vehicleVisibility,
              },
              (statusCode, response) => {
                for (let i = 0; i < response.data.data.length; i++) {
                  response.data.data[i].key = response.data.data[i]["id"];
                  response.data.data[i].duplicate = false;
                  delete response.data.data[i].id;
                }
                const getIcingOnly = response.data.data.filter(
                  (item) => parseInt(item.device_types_id) === 40
                );
                setVehicleList(getIcingOnly);
                setLoading(false);
              }
            );
          }
        );
      }
    );
    loadLocationGroup(
      {
        companyID: props.companyId,
        location_visibility: props.locationVisibility,
        location_group_visibility: props.location_group_visibility,
      },
      (statusCode, response) => {
        setLocationGroup(response.data.data);
      }
    );
    loadPlants(
      {
        company_id: props.companyId,
        location_visibility: props.locationVisibility,
      },
      (statusCode, response) => {
        if (response.status == 200) {
          for (let i = 0; i < response.data.data.length; i++) {
            response.data.data[i].key = response.data.data[i]["id"];
            response.data.data[i].duplicate = false;
            delete response.data.data[i].id;
          }
          setPlant(response.data.data);
        }
      }
    );
  };

  const handleChangeTransfer = (
    nextTargetKeys,
    direction,
    moveKeys,
    setFieldValue,
    key
  ) => {
    setFieldValue(key, nextTargetKeys);
  };

  const checkInitialValues = () => {
    if (props.type == "edit" && !!dataFromEdit) {
      return {
        name: dataFromEdit["name"],
        broadcastType: dataFromEdit["broadcast_type"],
        source: dataFromEdit["audio_id"],
        start: !!dataFromEdit["start_at"]
          ? moment(dataFromEdit["start_at"], "HH:mm")
          : moment(),
        end: !!dataFromEdit["end_at"]
          ? moment(dataFromEdit["end_at"], "HH:mm")
          : moment().add(1, "minutes"),
        time: dataFromEdit["alarm_time"],
        distanceTime: moment.utc(Number(dataFromEdit["interval_time"]) * 1000),
        vehicleGroup: "all",
        vehicleSelected: dataFromEdit["vehicle_list"],
        plantSelected: dataFromEdit["location_list"],
        status: dataFromEdit["is_active"],
        currentTab: dataFromEdit["data_type"],
        sourceURL: dataFromEdit["audio_url"],
      };
    } else {
      return {
        name: "",
        broadcastType: "immediately",
        source: "",
        start: moment(),
        end: moment().add(1, "minutes"),
        time: 1,
        distanceTime: moment.utc(
          Number(process.env.REACT_APP_BROADCAST_INTERVAL_TIME) * 1000
        ),
        vehicleGroup: "all",
        vehicleSelected: [],
        locationGroup: "all",
        plantSelected: [],
        status: true,
        currentTab: "plant",
        audioList: [],
      };
    }
  };

  const goBack = () => {
    window.location.replace("/broadcast-to-icing");
  };

  const getVehicleByVehicleGroup = (vehicle_groups_id, setFieldValue) => {
    let vehicleArr = [];
    loadVehicleByVehicleGroup(
      {
        company_id: props.companyId,
        vehicle_visibility: props.vehicleVisibility,
        vehicle_groups_id,
      },
      (statusCode, response) => {
        if (response.data.data.length > 0) {
          response.data.data.map((item) => {
            vehicleArr.push(item.id);
          });
        }
        setFieldValue("vehicleGroup", vehicle_groups_id);
        setFieldValue("vehicleSelected", vehicleArr);
      }
    );
  };

  const getLocationByLocationBroup = (location_group_id, setFieldValue) => {
    let LocationArr = [];
    loadLocationByLocationGroup(
      {
        location_group_id,
      },
      (statusCode, response) => {
        if (response.data.data.length > 0) {
          response.data.data.map((item) => {
            LocationArr.push(item);
          });
        }
        setFieldValue("locationGroup", location_group_id);
        setFieldValue("plantSelected", LocationArr);
      }
    );
  };

  const radioStyle = {
    display: "block",
    height: "30px",
    lineHeight: "30px",
  };

  return (
    <GeneralStyledContent>
      <Spin spinning={loading}>
        <Row gutter={24}>
          <Col span={24}>
            <Breadcrumb
              match={props.match}
              style={{ margin: "0px 0px 14px 10px" }}
            />
          </Col>
        </Row>
        <Row>
          <StyledSearchForm>
            <Formik
              initialValues={checkInitialValues()}
              enableReinitialize={true}
              validationSchema={yup.object().shape({
                name: yup.string().required("กรุณากรอกชื่อ"),
                broadcastType: yup
                  .string()
                  .required("กรุณาเลือกประเภทของ Broadcast"),
                source: yup.string().required("กรุณาเลือกไฟล์เสียง"),
                start: yup.mixed().required("กรุณาเลือกเวลาเริ่มต้น"),
                end: yup
                  .mixed()
                  .required("กรุณาเลือกเวลาสิ้นสุด")
                  .test(
                    "is-after-start",
                    "เวลาสิ้นสุดต้องไม่ต่ำกว่าเวลาเริ่มต้น",
                    function(value) {
                      const { start } = this.parent;
                      if (!start || !value) return true; // ยังไม่กรอกครบ ไม่ต้อง error
                      return value.isSameOrAfter(start);
                    }
                  ),
                currentTab: yup
                  .string()
                  .oneOf(["plant", "vehicle"])
                  .required(),
                plantSelected: yup.array().when("currentTab", {
                  is: "plant",
                  then: yup
                    .array()
                    .min(1, "กรุณาเลือกอย่างน้อย 1 Plant")
                    .required("กรุณาเลือก Plant"),
                  otherwise: yup.array(),
                }),
                vehicleSelected: yup.array().when("currentTab", {
                  is: "vehicle",
                  then: yup
                    .array()
                    .min(1, "กรุณาเลือกอย่างน้อย 1 Vehicle")
                    .required("กรุณาเลือก Vehicle"),
                  otherwise: yup.array(),
                }),
              })}
              onSubmit={(values) => {
                props.onSubmit(values);
              }}
              render={({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                handleFocus,
                setFieldValue,
              }) => {
                setFieldValueFormikRef.current = setFieldValue;
                return (
                  <Form onSubmit={handleSubmit}>
                    <FormDivider>Broadcast Icing</FormDivider>
                    <Row gutter={[32, 32]}>
                      <Col span={12}>
                        <Row gutter={[16, 16]}>
                          <Col span={24}>
                            <FormItem
                              label={
                                <LangContext.Consumer>
                                  {(i18n) => i18n.n.name}
                                </LangContext.Consumer>
                              }
                              required={true}
                              validateStatus={
                                touched.name && errors.name && "error"
                              }
                              help={touched.name && errors.name}
                            >
                              <Input
                                placeholder="กรอกชื่อ..."
                                style={{ width: "100%" }}
                                onChange={(e) => {
                                  setFieldValue("name", e.target.value);
                                }}
                                value={values.name}
                              />
                            </FormItem>
                          </Col>
                          <Col span={24}>
                            <FormItem
                              label={
                                <LangContext.Consumer>
                                  {(i18n) => i18n.b.broadcastType}
                                </LangContext.Consumer>
                              }
                              required={true}
                              validateStatus={
                                touched.broadcastType &&
                                errors.broadcastType &&
                                "error"
                              }
                              help={
                                touched.broadcastType && errors.broadcastType
                              }
                            >
                              <Radio.Group
                                onChange={(e) =>
                                  setFieldValue("broadcastType", e.target.value)
                                }
                                value={values.broadcastType}
                              >
                                <Radio
                                  style={radioStyle}
                                  value={"immediately"}
                                  disabled={props.type == "edit"}
                                >
                                  Broadcast ทันที{" "}
                                  <label style={{ color: "red" }}>
                                    (หากอุปกรณ์ไม่ได้รับข้อมูลภายใน 15
                                    นาทีจะไม่มีการส่งข้อมูลซ้ำ)
                                  </label>
                                </Radio>
                                <Radio
                                  style={radioStyle}
                                  value={"schedule"}
                                  disabled={props.type == "edit"}
                                >
                                  Broadcast ในช่วงเวลาที่กำหนด เมื่อ Engine On
                                </Radio>
                                <Radio
                                  style={radioStyle}
                                  value={"continuous"}
                                  disabled={props.type == "edit"}
                                >
                                  Broadcast จนกว่า Engine Off
                                </Radio>
                              </Radio.Group>
                            </FormItem>
                          </Col>
                          {values.broadcastType === "schedule" && (
                            <>
                              <Col span={4}>
                                <FormItem
                                  label={"ช่วงเวลาเริ่มต้น"}
                                  required={true}
                                  validateStatus={
                                    touched.start && errors.start && "error"
                                  }
                                  help={touched.start && errors.start}
                                >
                                  <TimePicker
                                    allowClear={false}
                                    value={values.start}
                                    format={"HH:mm"}
                                    onChange={(time) => {
                                      setFieldValue("start", time);

                                      // ถ้ามีค่า end แล้ว และ start ใหม่ > end เดิม → ปรับ end = start
                                      if (
                                        values.end &&
                                        time.isAfter(values.end)
                                      ) {
                                        const newEnd = moment(time).add(
                                          1,
                                          "minutes"
                                        );
                                        setFieldValue("end", newEnd);
                                      }
                                    }}
                                    style={{ width: "100%" }}
                                  />
                                </FormItem>
                              </Col>
                              <Col span={4}>
                                <FormItem
                                  label={"ช่วงเวลาสิ้นสุด"}
                                  required={true}
                                  validateStatus={
                                    touched.end && errors.end && "error"
                                  }
                                  help={touched.end && errors.end}
                                >
                                  <TimePicker
                                    allowClear={false}
                                    value={values.end}
                                    format={"HH:mm"}
                                    onChange={(time) => {
                                      setFieldValue("end", time);
                                    }}
                                    style={{ width: "100%" }}
                                  />
                                </FormItem>
                              </Col>
                            </>
                          )}
                          {values.broadcastType === "immediately" ||
                          values.broadcastType === "schedule" ? (
                            <Col span={8}>
                              <FormItem
                                label={"จำนวนครั้ง"}
                                required={true}
                                validateStatus={
                                  touched.time && errors.time && "error"
                                }
                                help={touched.time && errors.time}
                              >
                                <InputNumber
                                  style={{ width: "100%" }}
                                  min={1}
                                  value={values.time}
                                  onChange={(value) => {
                                    setFieldValue("time", value);
                                  }}
                                />
                              </FormItem>
                            </Col>
                          ) : null}
                          {["immediately", "schedule", "continuous"].includes(
                            values.broadcastType
                          ) && (
                            <Col span={8}>
                              <FormItem
                                label={"ระยะห่างกันต่อครั้ง กี่นาที:วินาที"}
                                required={true}
                                validateStatus={
                                  touched.duration && errors.duration && "error"
                                }
                                help={touched.duration && errors.duration}
                              >
                                <TimePicker
                                  allowClear={false}
                                  value={values.distanceTime}
                                  format={"mm:ss"}
                                  onChange={(time) => {
                                    if (
                                      time &&
                                      time.minutes() === 0 &&
                                      time.seconds() === 0
                                    ) {
                                      message.warning(
                                        "ระยะห่างต้องไม่น้อยกว่า 1 วินาที"
                                      );
                                      // setFieldValue(
                                      //   "distanceTime",
                                      //   moment("00:01", "mm:ss")
                                      // );
                                      return;
                                    }
                                    setFieldValue("distanceTime", time);
                                  }}
                                  style={{ width: "100%" }}
                                  disabledTime={() => ({
                                    disabledMinutes: () => [],
                                    disabledSeconds: (
                                      selectedHour,
                                      selectedMinute
                                    ) => (selectedMinute === 0 ? [0] : []),
                                  })}
                                />
                              </FormItem>
                            </Col>
                          )}

                          <Col span={22}>
                            <FormItem
                              label={"เลือกเสียง"}
                              required={true}
                              validateStatus={
                                touched.source && errors.source && "error"
                              }
                              help={touched.source && errors.source}
                            >
                              <Select
                                value={values.source}
                                onChange={(e) => {
                                  setFieldValue("sourceURL", "");
                                  setTimeout(() => {
                                    const selectedAudio = values.audioList.find(
                                      (item) => item.id === e
                                    );
                                    setFieldValue("source", e);
                                    setFieldValue(
                                      "sourceURL",
                                      selectedAudio.link_file
                                    );
                                  }, 1000);
                                }}
                                onFocus={() => {
                                  getAudioList(
                                    {
                                      company_id: props.companyId,
                                    },
                                    (status, response) => {
                                      if (response.status == 200) {
                                        setFieldValue(
                                          "audioList",
                                          response.data
                                        );
                                      }
                                    }
                                  );
                                }}
                                placeholder="กรุณาเลือกเสียง"
                              >
                                {values.audioList &&
                                  values.audioList.map((item) => (
                                    <Select.Option
                                      key={item.id}
                                      value={item.id}
                                    >
                                      {item.name}
                                    </Select.Option>
                                  ))}
                              </Select>
                            </FormItem>
                          </Col>
                          <Col span={2}>
                            <Button
                              type="link"
                              style={{ marginTop: 31 }}
                              onClick={() => {
                                window.open("/voice-management", "_blank");
                              }}
                            >
                              เพิ่มเสียง
                            </Button>
                          </Col>
                          {values.sourceURL && (
                            <Col span={24}>
                              <FormItem
                                label={
                                  <LangContext.Consumer>
                                    {(i18n) => i18n.p.preview}
                                  </LangContext.Consumer>
                                }
                              >
                                <AudioPlayer blobUrl={values.sourceURL} />
                              </FormItem>
                            </Col>
                          )}
                          {["schedule", "continuous"].includes(
                            values.broadcastType
                          ) && (
                            <Col span={24}>
                              <FormItem
                                label={
                                  <LangContext.Consumer>
                                    {(i18n) => i18n.s.status}
                                  </LangContext.Consumer>
                                }
                              >
                                <Switch
                                  checkedChildren={<Icon type="check" />}
                                  unCheckedChildren={<Icon type="close" />}
                                  checked={values.status}
                                  onChange={(checked) => {
                                    setFieldValue("status", checked);
                                  }}
                                />
                              </FormItem>
                            </Col>
                          )}

                          <Col span={24}>
                            <Button
                              type="default"
                              style={{
                                marginRight: "10px",
                              }}
                              onClick={goBack}
                            >
                              <LangContext.Consumer>
                                {(i18n) => i18n.b.back}
                              </LangContext.Consumer>
                            </Button>
                            <Button type="primary" htmlType="submit">
                              <LangContext.Consumer>
                                {(i18n) => i18n.s.submit}
                              </LangContext.Consumer>
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={12}>
                        <Tabs
                          activeKey={values.currentTab}
                          onChange={(key) => {
                            if (key === "plant") {
                              setFieldValue("vehicleSelected", []);
                              setFieldValue("vehicleGroup", "all");
                            } else {
                              setFieldValue("plantSelected", []);
                              setFieldValue("locationGroup", "all");
                            }
                            setFieldValue("currentTab", key);
                          }}
                        >
                          <TabPane tab="plant / จุดโหลดของ" key="plant">
                            <FormItem>
                              <label
                                style={{
                                  fontSize: 20,
                                  fontWeight: "bold",
                                }}
                              >
                                พาหนะ
                              </label>
                              <Divider style={{ margin: "10px 0px" }} />
                            </FormItem>
                            <FormItem
                              label={
                                <LangContext.Consumer>
                                  {(i18n) => i18n.l.locationGroup}
                                </LangContext.Consumer>
                              }
                              validateStatus={
                                touched.locationGroup &&
                                errors.locationGroup &&
                                "error"
                              }
                              help={
                                touched.locationGroup && errors.locationGroup
                              }
                            >
                              <Select
                                style={{ width: "100%" }}
                                placeholder="กรุณาเลือก"
                                optionFilterProp="children"
                                value={values.locationGroup}
                                onChange={(e) => {
                                  getLocationByLocationBroup(e, setFieldValue);
                                }}
                              >
                                <Select.Option value={"all"}>
                                  <LangContext.Consumer>
                                    {(i18n) => i18n.a.all}
                                  </LangContext.Consumer>
                                </Select.Option>
                                {locationGroup.map((item) => (
                                  <Select.Option
                                    key={item.location_groups_id.toString()}
                                    value={item.location_groups_id}
                                  >
                                    {item.location_group_name}
                                  </Select.Option>
                                ))}
                              </Select>
                            </FormItem>
                            <FormItem
                              label={"ชื่อสถานที่ที่เป็นประเภทจุดโหลดของ"}
                              validateStatus={
                                touched.plantSelected &&
                                errors.plantSelected &&
                                "error"
                              }
                              required={true}
                              help={
                                touched.plantSelected && errors.plantSelected
                              }
                            >
                              <TableTransfer
                                dataSource={plant}
                                targetKeys={values.plantSelected}
                                showSearch
                                onChange={(
                                  nextTargetKeys,
                                  direction,
                                  moveKeys
                                ) => {
                                  handleChangeTransfer(
                                    nextTargetKeys,
                                    direction,
                                    moveKeys,
                                    setFieldValue,
                                    "plantSelected"
                                  );
                                }}
                                filterOption={(inputValue, item) =>
                                  item.name
                                    .toUpperCase()
                                    .indexOf(inputValue.toUpperCase()) !== -1
                                }
                                leftColumns={[
                                  {
                                    dataIndex: "name",
                                    title: (
                                      <div style={{ fontSize: 15 }}>
                                        <LangContext.Consumer>
                                          {(i18n) => i18n.i.itemLeft}
                                        </LangContext.Consumer>
                                      </div>
                                    ),
                                    position: "Left",
                                    render: (text, record) => {
                                      return (
                                        <div>
                                          <span
                                            style={{
                                              fontSize: 13,
                                              color: "rgba(0, 0, 0, 0.65)",
                                            }}
                                          >
                                            ({record.code}) - {text}
                                          </span>
                                        </div>
                                      );
                                    },
                                  },
                                ]}
                                rightColumns={[
                                  {
                                    dataIndex: "name",
                                    title: (
                                      <div style={{ fontSize: 15 }}>
                                        <LangContext.Consumer>
                                          {(i18n) => i18n.i.itemSelected}
                                        </LangContext.Consumer>
                                      </div>
                                    ),
                                    position: "Right",
                                    render: (text, record) => {
                                      return (
                                        <div>
                                          <span
                                            style={{
                                              fontSize: 13,
                                              color: "rgba(0, 0, 0, 0.65)",
                                            }}
                                          >
                                            ({record.code}) - {text}
                                          </span>
                                        </div>
                                      );
                                    },
                                  },
                                ]}
                              />
                            </FormItem>
                          </TabPane>
                          <TabPane tab="พาหนะ" key="vehicle">
                            <FormItem>
                              <label
                                style={{
                                  fontSize: 20,
                                  fontWeight: "bold",
                                }}
                              >
                                พาหนะ
                              </label>
                              <Divider style={{ margin: "10px 0px" }} />
                            </FormItem>
                            <FormItem
                              label={
                                <LangContext.Consumer>
                                  {(i18n) => i18n.v.vehicleGroup}
                                </LangContext.Consumer>
                              }
                              validateStatus={
                                touched.vehicleGroup &&
                                errors.vehicleGroup &&
                                "error"
                              }
                              help={touched.vehicleGroup && errors.vehicleGroup}
                            >
                              <Select
                                style={{ width: "100%" }}
                                placeholder="กรุณาเลือก"
                                optionFilterProp="children"
                                value={values.vehicleGroup}
                                onChange={(e) => {
                                  getVehicleByVehicleGroup(e, setFieldValue);
                                }}
                              >
                                <Select.Option value={"all"}>
                                  <LangContext.Consumer>
                                    {(i18n) => i18n.a.all}
                                  </LangContext.Consumer>
                                </Select.Option>
                                {vehicleGroup.map((item) => (
                                  <Select.Option
                                    key={item.id.toString()}
                                    value={item.id}
                                  >
                                    {item.name}
                                  </Select.Option>
                                ))}
                              </Select>
                            </FormItem>
                            <FormItem
                              label={
                                <LangContext.Consumer>
                                  {(i18n) => i18n.v.vehicle}
                                </LangContext.Consumer>
                              }
                              validateStatus={
                                touched.vehicleSelected &&
                                errors.vehicleSelected &&
                                "error"
                              }
                              help={
                                touched.vehicleSelected &&
                                errors.vehicleSelected
                              }
                              required={true}
                            >
                              <TableTransfer
                                dataSource={vehicleList}
                                targetKeys={values.vehicleSelected}
                                showSearch
                                onChange={(
                                  nextTargetKeys,
                                  direction,
                                  moveKeys
                                ) => {
                                  handleChangeTransfer(
                                    nextTargetKeys,
                                    direction,
                                    moveKeys,
                                    setFieldValue,
                                    "vehicleSelected"
                                  );
                                }}
                                filterOption={(inputValue, item) => {
                                  const search = inputValue.toUpperCase();
                                  return (
                                    (item.plate_no &&
                                      item.plate_no
                                        .toUpperCase()
                                        .includes(search)) ||
                                    (item.code &&
                                      item.code.toUpperCase().includes(search))
                                  );
                                }}
                                leftColumns={[
                                  {
                                    dataIndex: "plate_no",
                                    title: (
                                      <div style={{ fontSize: 15 }}>
                                        <LangContext.Consumer>
                                          {(i18n) => i18n.i.itemLeft}
                                        </LangContext.Consumer>
                                      </div>
                                    ),
                                    key: "plate_no",
                                    position: "Left",
                                    render: (text, record) => {
                                      return (
                                        <div>
                                          <span
                                            style={{
                                              fontSize: 13,
                                              color: "rgba(0, 0, 0, 0.65)",
                                            }}
                                          >
                                            ({record.code}) - {text}
                                          </span>
                                        </div>
                                      );
                                    },
                                  },
                                ]}
                                rightColumns={[
                                  {
                                    dataIndex: "plate_no",
                                    key: "plate_no",
                                    title: (
                                      <div style={{ fontSize: 15 }}>
                                        <LangContext.Consumer>
                                          {(i18n) => i18n.i.itemSelected}
                                        </LangContext.Consumer>
                                      </div>
                                    ),
                                    position: "Right",
                                    render: (text, record) => {
                                      return (
                                        <div>
                                          <span
                                            style={{
                                              fontSize: 13,
                                              color: "rgba(0, 0, 0, 0.65)",
                                            }}
                                          >
                                            ({record.code}) - {text}
                                          </span>
                                        </div>
                                      );
                                    },
                                  },
                                ]}
                              />
                              <label style={{ color: "red" }}>
                                *เฉพาะ ICING เท่านั้น
                              </label>
                            </FormItem>
                          </TabPane>
                        </Tabs>
                      </Col>
                    </Row>
                  </Form>
                );
              }}
            />
          </StyledSearchForm>
        </Row>
      </Spin>
    </GeneralStyledContent>
  );
};

export default BroadcastForm;
